<div class="container-fluid">
  <div class="row">
    <div class="col-12">

      <ul ngbNav #nav="ngbNav" class="nav-tabs detail-tabs tabs-api-docs no-border" [activeId]="preSelectedTab" (navChange)="updateLink($event.nextId)">
        <li *ngFor="let type of types" [ngbNavItem]="type">
          <button ngbNavLink>{{ type | uppercase }}</button>
          <ng-template ngbNavContent>
            <iframe #iframe [src]="link" frameborder="0"></iframe>
          </ng-template>
        </li>
      </ul>
      <div [ngbNavOutlet]="nav"></div>

      <div>
      </div>
    </div>
